import React, { useCallback, useEffect, useRef, useState } from 'react';
import LoanStatusPill from 'Feature/V2/HbtMasterPool/shared/LoanStatusPill';
import PortfolioLoanStatusPill from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementRequestOverview/components/HbtPortfolioLoansInventoryTable/LoanStatusPill';
import { getLoanStatusLabel } from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementRequestOverview/components/HbtPortfolioLoansInventoryTable/columns/loansInventoryTableCellRenderers';
import { loanStatusMapping as portfolioManagementStatusMapping } from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementRequestOverview/components/HbtPortfolioLoansInventoryTable/utils/LoanStatusMapping';
import { loanStatusMapping } from '../../../HbtMasterPoolTable/utils/LoanStatusMapping';
import { useTranslation } from 'react-i18next';
import { PortfolioInsuranceType } from './types';

interface ForceStatusPill {
  typeOfPortfolioInsurance: PortfolioInsuranceType;
  status: string;
}

export const ForceStatusPill = ({ typeOfPortfolioInsurance, status }: ForceStatusPill) => {
  const { t } = useTranslation('HbtMasterPool');
  const loanMapping = loanStatusMapping(t);

  if (typeOfPortfolioInsurance === 'validationReview') {
    return (
      <PortfolioLoanStatusPill
        status={status}
        label={getLoanStatusLabel(status as keyof typeof portfolioManagementStatusMapping, t)}
        filled={false}
      />
    );
  }
  return (
    <LoanStatusPill
      status={status}
      label={loanMapping[status as keyof typeof loanMapping]}
      filled={false}
    />
  );
};
